import { Skeleton } from "@mui/material"
import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import {
  usePositionsValue,
  useProfitAndLoss,
} from "@/App/Equities/shared/services/positions"
import {
  formatCurrency,
  formatPercentageSigned,
  formatProfitAndLoss,
  getChangeTextColor,
} from "@/App/Equities/shared/utils"
import { Stack, Typography } from "@/generated/material"

import { MOBILE_POSITIONS_PAGE_LOCATORS } from "./locators"

export const PositionsHeader = () => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Typography variant="Display md/Semibold">{t("myPositions")}</Typography>
      <Stack flexDirection="row" gap="md">
        <Subscribe fallback={<Skeleton width={50} />}>
          <PositionsValue />
        </Subscribe>
        <Subscribe fallback={<Skeleton width={50} />}>
          <ProfitAndLoss />
        </Subscribe>
      </Stack>
    </Stack>
  )
}

const PositionsValue = () => {
  const positionsValue = usePositionsValue()
  return (
    <Typography
      variant="Text xl/Semibold"
      data-testid={MOBILE_POSITIONS_PAGE_LOCATORS.positionsValue}
    >
      {formatCurrency(positionsValue)}
    </Typography>
  )
}

const ProfitAndLoss = () => {
  const { pnl, pnlPercent } = useProfitAndLoss("total")

  return (
    <Typography
      variant="Text xl/Regular"
      color={getChangeTextColor({ change: pnl })}
      data-testid={MOBILE_POSITIONS_PAGE_LOCATORS.totalProfitLoss}
    >
      {formatProfitAndLoss(pnl)} ({formatPercentageSigned(pnlPercent)})
    </Typography>
  )
}
